@if (inquiry) {
  <div [class]="'inquiry-card tone-' + tone" role="button" tabindex="0" (click)="onOpen()" (keydown.enter)="onOpen()">
    <div class="inquiry-card-head">
      <tidy-image [src]="platformIcon" class="inquiry-card-platform" />
      <tidy-text [smallBody]="'Booking inquiry'" class="inquiry-card-kicker" />
      <span class="inquiry-card-pill">
        <tidy-text [smallBody]="statusLabel" />
      </span>
    </div>

    @if (amountLabel) {
      <div class="inquiry-card-amount-row">
        <tidy-text [header]="amountLabel" [translate]="false" class="inquiry-card-amount" />
        <tidy-text [smallHelper]="amountCaption" class="inquiry-card-amount-caption" />
      </div>
    }

    <div class="inquiry-card-meta">
      <div class="inquiry-card-meta-item">
        <tidy-image [src]="'assets/svg/calendar-outline.svg'" class="inquiry-card-meta-icon" />
        <tidy-text [body]="stayLabel" [translate]="!dateRange" />
      </div>
      <div class="inquiry-card-meta-item">
        <tidy-image [src]="'assets/svg/people-outline.svg'" class="inquiry-card-meta-icon" />
        <tidy-text [body]="guestsLabel" [translate]="false" />
      </div>
    </div>

    @if (deadlineLabel) {
      <div class="inquiry-card-deadline" [class.passed]="isDeadlinePassed">
        <tidy-image [src]="'assets/svg/alarm-outline.svg'" class="inquiry-card-meta-icon" />
        @if (isDeadlinePassed) {
          <tidy-text [smallBody]="'Response window passed'" />
        } @else {
          <tidy-text [smallBody]="('Respond by ' | translate) + deadlineLabel" [translate]="false" />
        }
      </div>
    }

    <div class="inquiry-card-foot">
      <tidy-text [actionBody]="'View inquiry'" class="link" />
      <tidy-image [src]="'assets/svg/arrow-forward-outline.svg'" class="inquiry-card-foot-icon" />
    </div>
  </div>
}
